export class Marketing {
    id = null;
    name = null;
    code = null;
    fromDate = null;
    toDate = null;
}